<mat-card>
  <mat-card-content>
    <div class="content" [innerHTML]="document?.content"></div>
  </mat-card-content>
</mat-card>
